<template>
    <div>
        <a-table :columns="columns" 
                 :data-source="categories" 
                 :pagination="{pageSize: pageSize}"
                 rowKey="categoryId"
        >

            <template slot="index" slot-scope="text, record, index">
                <p>{{ index + 1 }}</p>
            </template>

            <template slot="actions" slot-scope="record">
				<a-button-group>
					<a-button shape="circle" icon="form" size="small" @click="handleBtnEdit(record)"/>
				</a-button-group>
			</template>

        </a-table>

        <category-edit-view-modal ref="categoryEditModal"/>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import CategoryEditViewModal from './CategoryEditViewModal.vue'

export default {

    components : {
        CategoryEditViewModal
    },

    data () {
        return {
            pageSize: 5, 
            columns : [
                {
					title: '#',
					dataIndex: 'index',
                    scopedSlots: { customRender: 'index' },
				},
                
                {
					title: 'CATEGORY',
					dataIndex: 'name',
				},

                {
					title: 'DESCRIPTION',
					dataIndex: 'description',
				},
                
                {
			        title : 'ACTIONS',
			        scopedSlots : { customRender: 'actions'},
			        fixed: 'right'
		        }
            ]
        }
    },
    computed : {
        ...mapGetters({

        }),
        ...mapState({
            categories : state => state.categories.categories
        })
    },

    methods : {

        handleBtnEdit(record) {
            this.$refs['categoryEditModal'].showModal(record);
        }
    }

}
</script>